const State = Backbone.Model.extend({
  defaults: {
    "stateId": null,
    "stateDesc": "",
    "Value": null,
    "Text": ""
  },
  idAttribute: "stateId",
  initialize() {
    this.set({ 'Value': this.get('stateId'), 'Text': this.get('stateDesc') });
  }
});

const States = Backbone.Collection.extend({
  model: State,
  url: `${$('body').data('apidomain')}lookup/states`,
	fetched: false,
	initialize() {
		this.on('sync', () => {
			this.fetched = true;
		});
		this.fetch();
	},
	parse(resp, opts) {
		return resp.states;
	},
  filteredList(countryID) {
	  return _.filter(this.models, (model) => {
	    return model.get('countryId') === countryID
    });
  }
});

export default States;
